import { EMPTY_CELL_HYPHEN, EM_DASH } from "constants/index";

import { FC } from "react";

import {
  dimUnitDictionary,
  freightClassDictionary,
  palletPackagingTypeOptions,
} from "app/pages/shipments/components/EditableShipmentPackageGroupElements";
import { ShipmentPackageGroup } from "app/pages/shipments/types/domain";
import { ResourceKey } from "i18next";
import { useTranslation } from "react-i18next";
import { formatCommodities } from "utils/formatCommodities";
import { formatWeight } from "utils/formatUnit";

interface ShipmentCargoDetailsViewProps {
  package_groups: ShipmentPackageGroup[] | null;
}

export const ShipmentCargoDetailsView: FC<ShipmentCargoDetailsViewProps> = ({ package_groups }) => {
  const { t } = useTranslation(["common", "shipper", "shipments"]);

  const [totalItemCount, totalWeight] = (package_groups || []).reduce(
    (acc, { itemQuantity, weightPerPackage }) => [acc[0] + itemQuantity, acc[1] + weightPerPackage * itemQuantity],
    [0, 0]
  );

  return (
    <>
      <div className="border-b border-border grid grid-cols-7 font-bold uppercase px-[16px] py-[14px]">
        <span>item</span>
        <span>stackable</span>
        <span>class</span>
        <span>nmfc</span>
        <span>weight</span>
        <span>dimensions</span>
        <span>commodities</span>
      </div>
      {package_groups?.map(
        ({
          id,
          itemQuantity,
          packagingType,
          commodities,
          freightClass,
          dimUnit,
          nmfcCode,
          weightPerPackage,
          widthPerPackage,
          heightPerPackage,
          lengthPerPackage,
          isStackable,
        }) => (
          <div key={id} className="grid grid-cols-7 odd:bg-zebra px-[16px] py-[14px]">
            <span className="font-bold">{`${itemQuantity} x ${t(
              ("shipper:packingTypeMap." + packagingType) as ResourceKey
            )}`}</span>
            <span>
              {palletPackagingTypeOptions.includes(packagingType)
                ? isStackable
                  ? t("common:yes")
                  : t("common:no")
                : EM_DASH}
            </span>
            <span>{freightClass ? freightClassDictionary[freightClass] : EMPTY_CELL_HYPHEN}</span>
            <span>{nmfcCode || EMPTY_CELL_HYPHEN}</span>
            <span>{formatWeight(weightPerPackage * itemQuantity, "lb")}</span>
            <span>
              {t("common:dimensions_lwh", {
                length: lengthPerPackage,
                width: widthPerPackage,
                height: heightPerPackage,
                dimension: dimUnit ? dimUnitDictionary[dimUnit || ""] : "in",
              })}
            </span>
            <span>{formatCommodities(commodities)}</span>
          </div>
        )
      )}
      <div className="grid grid-cols-7 px-[16px] py-[14px]">
        <span className="font-bold">
          {t("shipments:shipmentDetails_cargoDetails_totalItems", { count: totalItemCount })}
        </span>
        <span />
        <span />
        <span />
        <span>{formatWeight(totalWeight, "lb")}</span>
        <span />
        <span />
      </div>
    </>
  );
};
